import { LocalStorageKey } from '../enums/localStorageKey.enum';

export const getDataFromLocalStorage = <T>(localStorageKey: LocalStorageKey): T | undefined => {
  const item = localStorage.getItem(localStorageKey);

  if (!item) return undefined;
  try {
    return JSON.parse(item) as T;
  } catch {
    return (item as unknown) as T;
  }
};
